import { render } from "./RiCall.vue?vue&type=template&id=302826ab"
import script from "./RiCall.vue?vue&type=script&lang=js"
export * from "./RiCall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiCall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "302826ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('302826ab', __exports__)) {
    api.reload('302826ab', __exports__)
  }
  
  module.hot.accept("./RiCall.vue?vue&type=template&id=302826ab", () => {
    api.rerender('302826ab', render)
  })

}


export default __exports__